/*
 * Copyright (c) 2023 Class Technologies Inc. All rights reserved.
 */

import React from 'react';

import styled from 'styled-components';

import classLogo from '../images/class-logo-reversed.svg';

const StyledImage = styled.img`
    max-width: 24px;
    max-height: 24px;
`;

const ClassLogoForHeader = () => <StyledImage src={classLogo} alt="class logo"/>;

export default ClassLogoForHeader;
